import { useMemo } from 'react';

import { LoadedFile } from '@hh.ru/magritte-ui-upload/types';

interface UseFilePreviewProps {
    loadedFile: LoadedFile | undefined;
    isImageType: boolean;
}

const useFilePreview = ({ loadedFile, isImageType }: UseFilePreviewProps): string => {
    return useMemo(() => {
        if (!loadedFile || !isImageType) {
            return 'none';
        }
        if (loadedFile.loading || loadedFile.error) {
            return 'none';
        }
        return URL.createObjectURL(loadedFile.data);
    }, [loadedFile, isImageType]);
};

export { useFilePreview };
